import React, { useEffect, useState } from 'react';
import RangeSlider from './RangeSlider';

const FilterRange = ({ data, handleSlider, query }) => {
  const extractedValues = data.value.map((el) => el);
  const thisMin = Math.round(Math.min(...extractedValues));
  const thisMax = Math.round(Math.max(...extractedValues));

  const [value, setValue] = useState({ min: thisMin, max: thisMax });

  const initialRange = {
    min: thisMin,
    max: thisMax,
  };

  useEffect(() => {
    const queryCopy = [...query];
    if (!queryCopy.length) {
      setValue({ min: thisMin, max: thisMax });
    }
  }, [query]);

  const handleRanger = (sliderVal) => {
    setValue(sliderVal);
    handleSlider(data, sliderVal);
  };

  const formatNumber = (val) => {
    const num = parseInt(val);
    const formattedMsrp = num.toLocaleString();

    return `${formattedMsrp}`;
  };

  return (
    <>
      <div className="range-watcher">
        <span>{formatNumber(value.min)}</span>
        <span>{formatNumber(value.max)}</span>
      </div>
      <RangeSlider
        min={parseInt(thisMin)}
        max={parseInt(thisMax)}
        step={1}
        value={value}
        onChange={handleRanger}
      />
      <div className="range-watcher defaults">
        <span>{formatNumber(thisMin)}</span>
        <span>{formatNumber(thisMax)}</span>
      </div>
    </>
  );
};

export default FilterRange;
